<template>
  <section>
    <airline-list :query="query" />
  </section>
</template>

<script>
import AirlineList from '@/components/basic/AirlineList'

export default {
  name: 'Airlines',
  components: {
    AirlineList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
